// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"8c0c2120","328":"8aec17e7"}[chunkId] + ".chunk.css";
};